import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TransformDetail } from 'src/api/models';
import { Widget, Dashboard } from 'src/api/models'
import { DashboardService } from 'src/api/services';
import { ImageOverlayComponent } from 'src/app/components/image-overlay/image-overlay.component';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { StorageTablesService } from "src/service/storage-tables.service";

@Component({
  selector: "app-image-overlay-widget-editor",
  templateUrl: "./image-overlay-widget-editor.component.html",
  styleUrls: ["./image-overlay-widget-editor.component.css"],
})
export class ImageOverlayWidgetEditorComponent implements OnInit, IWidgetEditor {
  // @ViewChildren('sourceImage') sourceImages;
  @ViewChildren(ImageOverlayComponent) imgOverlayList: QueryList<ImageOverlayComponent>;

  public widgetType: WidgetType;
  public widget: ChartWidget;
  public dashboards: Dashboard[];
  public dashboard: Dashboard;
  public w: any;
  imageUrl = "";
  imageData="";
  imgOverlay:any = {objects:[]};
  fileError = false;

  public transformList: TransformDetail[];
  private colours: string[];

  constructor(public storageTablesService: StorageTablesService, public dashboardService: DashboardService) {
    this.colours = [
      '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];
  }

  ngOnInit() {
    this.w = this.widget;
    if (this.w.bandDetailList == null) this.w.bandDetailList = [];
    if (this.w.lineDetailList == null) this.w.lineDetailList = [];
    if (this.w.dataSourceDetailList == null) this.w.dataSourceDetailList = [];

    var i = 0;
    for (let tab of this.w.timeSeriesDetailList) {
      tab.removable = true;
      if (tab.colour == null){
          tab.colour = this.colours[i];
      }
      if (tab.default == null) tab.default = {};
      if (tab.primary == null) tab.primary = {};
      if (tab.success == null) tab.success = {};
      if (tab.info == null) tab.info = {};
      if (tab.warning == null) tab.default = {};
      if (tab.danger == null) tab.danger = {};
      if (tab.embeddedDashboard == null) tab.embeddedDashboard = { dashboardId: null};
      i++;
    }
    if (this.w.timeSeriesDetailList.length > 0) {
      this.w.timeSeriesDetailList[0].active = true;
    }
    this.dashboardService.DashboardGetMyDashboards().subscribe(d => {
      this.dashboards = d;
    });

    this.renderImageOverlay();
  }

  updateImage(){
    console.log(this.imgOverlayList);
    this.imgOverlayList.forEach(element => {
      element.showImage(true);
      element.update();
    });
    /*foreach (var imageOVerlay in this.sourceImages){
      this.imageOverlay.update();
    }*/
  }  

  public addItem() {
    this.w.timeSeriesDetailList.push({
      uri: " ",
      axis: 0,
      type: "tracker",
      style: "solid",
      showMarker: false,
      size: 1,
      displayOption:"text",
      active: true,
      removable: true,
      embeddedDashoard: {},
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: [],
      default:{},
      primary:{},
      success:{},
      info:{},
      warning:{},
      danger:{}
    });
  }

  public uploadImageFile(fileObj) {
    const file = fileObj.item(0);
    
    if(!window.FileReader) return; // Browser is not compatible
    var reader = new FileReader();
    var setImageData = (d) => {
      this.w.imageData  = d;
      this.renderImageOverlay();
      this.updateImage();
    };

    reader.onloadend = function(evt) {
      /*if (reader.result.length > 50000){
        this.fileError = true;
      } 
      else {
        this.fileError = false;
      }*/
      if(evt.target.readyState != 2) return;
      if(evt.target.error) {
          alert('Error while reading file');
          return;
      }
      setImageData(reader.result);
    };
    if (file.type == "image/svg+xml"){
      reader.readAsText(file);
    }else{
      reader.readAsDataURL(file);
    }    
  }

  public renderImageOverlay(){
    this.imageUrl = this.w.imageUrl;
    this.imageData = this.w.imageData;
  }


  public removeTimeSeries(timeSeries: any): void {
    var index = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.timeSeriesDetailList.splice(index, 1);
    }
  }

  public increaseX(tab:any){
    tab.x = tab.x + 0.1;
    this.updateImage();
  }

  public decreaseX(tab:any){
    tab.x = tab.x - 0.1;
    this.updateImage();
  }

  public increaseY(tab:any){
    tab.y = tab.y + 0.1;
    this.updateImage();
  }

  public decreaseY(tab:any){
    tab.y = tab.y - 0.1;
    this.updateImage();
  }
}
